/**
 * The LpSeaProductGrid component
 * Examples: https://www.meinfoto.de/angebot
 * Hero with CTA Button
 * CMS Blocks for Trust
 * Products / Product Examples
 * Perks
 */
import React from "react";
import PropTypes from "prop-types";
import { Container, Col, Row } from 'reactstrap';
import { Link } from "react-router-dom";
import Perks from '../../../components/Perks'
import CMSBlock from '../../../components/CMSBlock'

// FIXME enforce CMSBlockTeaser Layout
import CMSBlockTeaser from '../../../components/CMSBlock/utils/CMSBlockTeaser'

/**
 * Stateless react component to render the LpSeaProductGrid component
 * @param {Object} props the props passed to the page.
 */
const LpSeaProductGrid = (props, context) => {
  const {landingpage, productTeasers, cmsBlock1, cmsBlock2, cmsBlock3} = props;

  return (
    <div className="lp-product-grid">
      <div className="py-2 bg-light">
        <header className="container">
          { landingpage.title && <h1>{landingpage.title}</h1> }
          <Row>
            { cmsBlock1 && cmsBlock1[0] &&
              <Col lg={6}>
                <CMSBlock cmsBlock={cmsBlock1[0]} />
              </Col>
            }
        
            { cmsBlock2 && cmsBlock2[0] &&
              <Col lg={6}>
                <CMSBlock cmsBlock={cmsBlock2[0]} />
              </Col>
            }
          </Row>
        </header>
      </div>
      <Container className="my-5">
        <Row>
          { productTeasers && productTeasers.map(block =>
            <Col xl={3} md={6} key={block.id}>
              <CMSBlockTeaser key={`home_cms_block_${block.id}`} cmsBlock={block} />
            </Col>
          )}
        </Row>
      </Container>

      <div className="bg-light py-4">
        <Container>
          { landingpage.subtitle && <h2>{landingpage.subtitle}</h2> }
          { landingpage.intro &&
            <div dangerouslySetInnerHTML={{__html: landingpage.intro}} />
          }
          <Row>
            { landingpage.cta_title &&
              <Col md={{ size: 6, offset: 3}}>
                <Link to={`/${landingpage.language}/${landingpage.cta_link}`} className="btn btn-success btn-lg btn-block">{landingpage.cta_title}</Link>
              </Col>
            }
          </Row>
        </Container>
      </div>

      <Perks />

      { landingpage.content &&
        <Container className="my-5">
          <div dangerouslySetInnerHTML={{__html: landingpage.content}} />
        </Container>
      }

      { cmsBlock3 && cmsBlock3[0] &&
        <Container className="my-5">
          <CMSBlock cmsBlock={cmsBlock3[0]} />
        </Container>
      }

    </div>  
  );
}

/** define proptypes for the form */
LpSeaProductGrid.propTypes = {
  /** the item */
  landingpage: PropTypes.object.isRequired,
  productTeasers: PropTypes.array,
  cmsBlock1: PropTypes.array,
  cmsBlock2: PropTypes.array,
  cmsBlock3: PropTypes.array
};

/**  define proptype for the 'translation' function  */
LpSeaProductGrid.contextTypes = {
  t: PropTypes.func,
}
export default LpSeaProductGrid;
